import { TireTypeEnum } from './TireTypeEnum';
import { TireBrand } from '../TireBrand';
import { TireSize } from '../TireSize';
import { TireWear } from '../TireWear';
import { TireWidth } from '../TireWidth';
import { TireImage } from './TireImage';

export class TireStoringInfo {
  public id?: string;
  public seasonInfoId?: string;
  public no?: number;
  public type?: TireTypeEnum;
  public groove?: string | null = null;
  public tireBrand?: TireBrand | null = null;
  public size?: TireSize | null = null;
  public wear?: TireWear | null = null;
  public width?: TireWidth | null = null;
  public irregularWear?: number | null = null;
  public crack?: number | null = null;
  public scratchDeformation?: number | null = null;
  public hardness?: number | null = null;
  public imageId?: string;
  public imageScratch: TireImage[] = [];
  public file?: File;
  public fileScratch: File[] = [];
  public imageScratchIndex: number = 0;

  // Client only
  public imageUrl?: string = '';
  public imageScratchUrl: string[] = [];
  public items?: any = [];

  constructor(init?: Partial<TireStoringInfo>) {
    Object.assign(this, init);
  }
}
